import NFImage from "../images/404.png";
import { makeStyles } from "@material-ui/core/styles";

const useStyleNotFound = makeStyles((theme) => ({
  notfound: {
    //padding: theme.spacing(3, 2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "72vh",
    flexDirection: "column",

    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${NFImage})`,
  },
  h2: {
    fontSize: "2rem",
  },
  centratore: {
    textAlign: "center",
  },
}));

export default useStyleNotFound;
